const relationshipToCampersOptions = [
  'Mother',
  'Father',
  'Parent',
  'Stepmother',
  'Stepfather',
  'Stepparent',
  'Grandparent',
  'Legal Guardian / Other'
]

const phoneTypeOptions = [
  'Mobile',
  'Home',
  'Work'
]

export { relationshipToCampersOptions, phoneTypeOptions }
